// src/features/roles/rolesSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import permissionAccessConfig from 'src/contstant/permissionAccessConfig';
import { permissionService } from 'src/data/api/orbit-service/permissionService';
import { ApiRequestStatus, initApiStatus } from 'src/types/ApiRequestStatus';
import { ListPermissionRequest, Permission } from 'src/types/orbit/Permission';
import { handleError } from 'src/utils/generalUtils';

export interface PermissionState {
  permissions: Permission[];
  fetchPermissionsApiStatus: ApiRequestStatus;
}

const initialState: PermissionState = {
  permissions: [],
  fetchPermissionsApiStatus: initApiStatus,
};

export const fetchPermission = createAsyncThunk(
  'permission/fetchpermission',
  async (data: ListPermissionRequest, { rejectWithValue }) => {
    try {
      const response = await permissionService.getAll(data);

      return response;
    } catch (error: any) {
      return rejectWithValue(handleError(error));
    }
  },
);

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    clearPermissionList: (state) => {
      state.permissions = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermission.pending, (state) => {
        state.fetchPermissionsApiStatus.isLoading = true;
        state.fetchPermissionsApiStatus.errorMessage = null;
      })
      .addCase(fetchPermission.fulfilled, (state, action) => {
        state.fetchPermissionsApiStatus.isLoading = false;
        const excludedPermissions = [
          permissionAccessConfig.PERMISSIONS.EDIT_PERMISSIONS,
          permissionAccessConfig.BUSINESS_UNIT.EDIT_BUSINESS_UNIT,
        ] as string[];
        state.permissions = action.payload.permissions.filter(
          (permission: Permission) =>
            !excludedPermissions.includes(permission.permissionId),
        );
        state.fetchPermissionsApiStatus.nextToken = action.payload.nextToken;
      })
      .addCase(fetchPermission.rejected, (state, action) => {
        state.fetchPermissionsApiStatus.isLoading = false;
        state.fetchPermissionsApiStatus.errorMessage = action.payload as string;
      });
    // Add other cases for createRole, updateRole, etc.
  },
});

export const { clearPermissionList } = permissionSlice.actions;
export default permissionSlice.reducer;
